/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Button } from 'react-weui-ts';

const CommonButton = ({ title, type, onClick }: { title: string; type: 'normal' | 'active'; onClick?: () => void }) => {
    const normalStyle = {
        color: 'black',
        backgroundColor: '#F8F8F8',
    };
    const activeStyle = {
        color: '#CC962B',
        backgroundColor: '#FFF1D4',
    };

    const [customStyle, setStyle] = useState(normalStyle);

    useEffect(() => {
        if (type === 'normal') {
            setStyle(normalStyle);
        }
        if (type === 'active') {
            setStyle(activeStyle);
        }
    }, [type]);

    return (
        <>
            <Button
                type="default"
                size="small"
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    ...customStyle,
                }}
                className="common-button"
                onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
                    e.preventDefault();
                    onClick && onClick();
                }}
            >
                <span style={{ whiteSpace: 'nowrap' }}>{title}</span>
            </Button>
        </>
    );
};

export default CommonButton;
